// extracted by mini-css-extract-plugin
export default {"body":"Content_body__VsdFS"};